var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3839 12.9862C9.36367 12.9862 7.71338 11.4004 7.71338 9.43869C7.71338 7.47706 9.36367 5.90039 11.3839 5.90039C13.4041 5.90039 15.0544 7.48622 15.0544 9.44785C15.0544 11.4095 13.4041 12.9862 11.3839 12.9862ZM11.3839 7.27539C10.1509 7.27539 9.13605 8.24706 9.13605 9.44785C9.13605 10.6487 10.1414 11.6204 11.3839 11.6204C12.6264 11.6204 13.6317 10.6487 13.6317 9.44785C13.6317 8.24706 12.6169 7.27539 11.3839 7.27539Z",
    fill: "#1E241B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.383 20.864C9.97928 20.864 8.56609 20.3507 7.46589 19.3332C4.66798 16.7298 1.57605 12.5773 2.74264 7.63648C3.79541 3.15398 7.84527 1.14648 11.383 1.14648C11.383 1.14648 11.383 1.14648 11.3925 1.14648C14.9302 1.14648 18.98 3.15398 20.0328 7.64565C21.1899 12.5865 18.098 16.7298 15.3001 19.3332C14.1999 20.3507 12.7867 20.864 11.383 20.864ZM11.383 2.52148C8.623 2.52148 5.07581 3.94232 4.13685 7.93898C3.11253 12.2565 5.91993 15.9782 8.46176 18.334C10.1026 19.8648 12.6729 19.8648 14.3137 18.334C16.846 15.9782 19.6534 12.2565 18.6481 7.93898C17.6996 3.94232 14.143 2.52148 11.383 2.52148Z",
    fill: "#1E241B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.b63ac5ff27724d7d65a55d769ba8fffc.svg";
export { ForwardRef as ReactComponent };